/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature6Inputs */

const ja_playdata_pricing_feature6 = /** @type {(inputs: Playdata_Pricing_Feature6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競合チャンネル分析`)
};

const en_playdata_pricing_feature6 = /** @type {(inputs: Playdata_Pricing_Feature6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive channel analysis`)
};

/**
* | output |
* | --- |
* | "Competitive channel analysis" |
*
* @param {Playdata_Pricing_Feature6Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature6 = /** @type {((inputs?: Playdata_Pricing_Feature6Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature6Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature6(inputs)
	return en_playdata_pricing_feature6(inputs)
});